<template>
    <div>
        <div class="section-heading">
            <h4>Frequency</h4>
            <p>Add your product details</p>
            <p class="w-50 mt-3">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Provident porro eligendi modi
                esse nobis id voluptates, laudantium, quibusdam quos exercitationem consectetur nemo. Quo aliquid,
                error iusto nam facilis delectus reprehenderit cupiditate repudiandae, aut et sapiente praesentium
                earum aliquam optio ex ullam impedit consectetur facere sunt quasi. Dolores sit minima error natus
                cumque illo facilis, aliquid, praesentium id odit doloremque aspernatur quasi ea non nisi, itaque
                quaerat nostrum laborum tenetur ut dolor perspiciatis tempore! Architecto, eveniet ipsam a velit
                rerum labore nihil omnis mollitia suscipit distinctio ipsa odio corrupti molestiae odit ab nulla
                minus repudiandae pariatur fugit quis. Tempore, odit soluta accusamus ipsam, tempora, repellat omnis
                accusantium.</p>
        </div>

        <div class="section-heading mt-4">
            <table class="demo-table" v-if="Object.keys(selectedFrequency).length">
                <thead>
                    <tr>
                        <th>Features</th>
                        <th>Frequency</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row of selectedFeatures" :key="row.feature_id">
                        <td style="font-size: 14px;">{{ row.feature_name }}</td>
                        <td class="py-3 pl-2 text-left w-75">
                            <template class="d-flex">
                                <select class="demo-select" @change="selectedFrequency[row.feature_id]['frequency'] = 0"
                                    v-model="selectedFrequency[row.feature_id]['interval']">
                                    <option value="daily">Daily</option>
                                    <option value="weekly">Weekly</option>
                                    <option value="monthly">Monthly</option>
                                </select>
                                <select class="demo-select"
                                    v-if="selectedFrequency[row.feature_id]['interval'] === 'weekly'"
                                    v-model="selectedFrequency[row.feature_id]['frequency']">
                                    <option value="0" disabled>Select Day</option>
                                    <option value="1">Monday</option>
                                    <option value="2">Tuesday</option>
                                    <option value="3">Wednessday</option>
                                    <option value="4">Thursday</option>
                                    <option value="5">Friday</option>
                                    <option value="6">Saturday</option>
                                    <option value="7">Sunday</option>
                                </select>
                                <div class="d-inline-block position-relative"
                                    v-if="selectedFrequency[row.feature_id]['interval'] === 'monthly'" tabindex="0"
                                    @blur="closeDateContainer">
                                    <div class="dateInput"
                                        @click="selectedFrequency[row.feature_id]['isDatePickerOpen'] = !selectedFrequency[row.feature_id]['isDatePickerOpen']">
                                        {{ selectedFrequency[row.feature_id]['frequency'] || '_' }} of every month</div>
                                    <div class="dateContainer position-absolute"
                                        v-if="selectedFrequency[row.feature_id]['isDatePickerOpen']">
                                        <div class="d-flex justify-contents-between flex-wrap">
                                            <div v-for="date of 31"
                                                :class="selectedFrequency[row.feature_id]['frequency'] === date ? 'activeData' : 'datePicker'"
                                                class="d-flex justify-content-center mt-1 datePicker"
                                                @click="selectedFrequency[row.feature_id]['frequency'] = date">
                                                <span class="py-1">{{ date }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <vue-timepicker manual-input format="HH:mm"
                                    v-model="selectedFrequency[row.feature_id]['time']"></vue-timepicker>
                            </template>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="mt-4">
            <div class="d-flex">
                <button class="primarycolor mr-3" @click="saveSchedules">Save and Next</button>
                <button class="navigationButton" @click="setSelectedSection(previousSection)">Back</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Multiselect from "vue-multiselect";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
export default {
    name: "Prodcuts",
    components: {
        Multiselect,
        VueTimepicker
    },
    data() {
        return {
            isDateContainerOpen: false,
            selectedFrequency: {},
            invalidCheck: false,
            currentSectionIndex: null,
            nextSection: null,
            previousSection: null
        }
    },
    computed: {
        ...mapState("DemoStore", ['selectedFeatures', 'sections', 'selectedSection'])
    },
    mounted() {
        this.getSavedSchedules();
        this.currentSectionIndex = this.sections.indexOf(this.selectedSection)
        this.nextSection = this.sections[this.currentSectionIndex + 1];
        this.previousSection = this.sections[this.currentSectionIndex - 1];
    },
    methods: {
        ...mapActions("DemoStore", ['setDemoLoader', 'setSelectedSection']),
        closeDateContainer() {
            Object.values(this.selectedFrequency).forEach(frequency => frequency['isDatePickerOpen'] = false);
        },
        getSavedSchedules() {
            this.selectedFrequency = {};
            this.setDemoLoader(true);
            const url = "/api/demo/schedule";

            this.$http.get(url).then(res => {
                if (Object.keys(res.body.data).length) {
                    Object.entries(res.body.data).forEach(freq => {
                        this.selectedFrequency = {
                            ...this.selectedFrequency,
                            [freq[0]]: {
                                ...freq[1],
                                isDatePickerOpen: false
                            }
                        }
                    })
                } else {
                    this.selectedFeatures.forEach(feat => {
                        this.selectedFrequency = {
                            ...this.selectedFrequency,
                            [feat.feature_id]: {
                                interval: "daily",
                                frequency: 0,
                                time: "00:00",
                                isDatePickerOpen: false
                            }
                        }
                    });
                }
                this.setDemoLoader(false);
            }).catch(err => {
                console.log('Error in fetching the saved schedules', err)
                this.setDemoLoader(false);
            })
        },
        saveSchedules() {
            const url = "/api/demo/schedule";
            let payload = {};

            let error = false
            Object.keys(this.selectedFrequency).map(featFrequency => {
                if (!this.selectedFrequency[featFrequency].interval || !this.selectedFrequency[featFrequency].time) {
                    error = true;
                }else if (this.selectedFrequency[featFrequency].interval !== 'daily' && !this.selectedFrequency[featFrequency].frequency) {
                    error = true;
                } else {
                    payload = {
                        ...payload,
                        [featFrequency]: {
                            interval: this.selectedFrequency[featFrequency].interval,
                            frequency: this.selectedFrequency[featFrequency].frequency,
                            time: this.selectedFrequency[featFrequency].time
                        }
                    };
                }
            });

            if (error) {
                this.$bvToast.toast(`Please fill the fields for scheduling.`, {
                    title: "Weavr Sense",
                    variant: "danger",
                    toaster: "b-toaster-bottom-center",
                    autoHideDelay: 3000
                });
                return;
            }

            this.setDemoLoader(true);
            this.$http.post(url, payload).then(res => {
                this.setDemoLoader(false);
                this.setSelectedSection(this.nextSection)
            }).catch(err => {
                console.log("Error in saving scheduling frequency", err)
                this.setDemoLoader(false);
            });
        },
    },

}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.dateContainer {
    width: 200px !important;
    border: 1px solid var(--primary_brand-60);
    border-radius: 5px;
    padding: 3px;
    z-index: 2000 !important;
    background: #fff;
    top: 110%;
    left: 4%;
    color: var(--primary_brand);
}

.datePicker {
    width: 16%;
}

.activeData {
    background-color: var(--primary_brand);
    color: #fff;
    border-radius: 5px;
}

.datePicker:hover {
    margin-top: 2px;
    cursor: pointer;
    background-color: var(--primary_brand-80);
    color: #fff;
    border-radius: 5px;
}

.dateInput {
    display: flex;
    border: 1px solid var(--primary_brand);
    border-radius: 5px;
    color: var(--primary_brand);
    font-weight: 500;
    padding: 9px 20px;
    font-size: 16px;
    margin-inline: 8px;
    cursor: default;
}

.demo-select {
    font-family: "Poppins", sans-serif;
    color: var(--primary_brand);
    background-color: transparent;
    padding: 8px 16px;
    font-size: 16px;
    font-weight: 500;
    border: 1px solid #065559 !important;
    border-radius: 5px;
    margin-inline: 5px;
}

.demo-select:focus {
    border: 1px solid #065559 !important;
    box-shadow: none !important;
    outline: none !important;
}

.demo-input {
    padding: 4px 10px;
    border: 1px solid #EBEBEB;
    border-radius: 5px;
    color: var(--primary_brand);
}

.demo-input::placeholder {
    color: #919191;
    font-family: "Poppins", sans-serif;
}

.demo-input:focus {
    outline: none !important;
    box-shadow: none !important;
    border-color: var(--primary_brand) !important;
}

.demo-btn {
    color: #919191;
    background-color: transparent;
    border: 1px solid #EBEBEB;
    border-radius: 10px;
    padding: 6px 12px;
    margin-right: 20px;
    margin-bottom: 12px;
}

.demo-btn.active {
    color: var(--primary_brand);
    border: 1px solid var(--primary_brand);
}

.demo-btn:focus {
    outline: none !important;
    box-shadow: none !important;
    border-color: #EBEBEB !important;
}

.demo-btn.active:focus {
    outline: none !important;
    box-shadow: none !important;
    border-color: var(--primary_brand) !important;
}

.section-heading h4 {
    font-size: 18px;
    font-weight: 600;
}

.section-heading p {
    color: #5E5E5E;
    font-size: 14px;
    font-weight: 500;
}

.navigationButton {
    height: 35px;
    border: none;
    margin: 0;
    background: var(--accent_color);
    color: white;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    padding: 0px 20px;
    letter-spacing: 0.2px;
    font-family: "poppins", sans-serif;
}

.navigationButton:hover {
    background: var(--accent_color-80);
}

.navigationButton:focus {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
}

button.primarycolor {
    height: 35px;
    border: none !important;
    margin: 0;
    background: var(--primary_brand);
    color: white;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    padding: 0px 20px;
    letter-spacing: 0.2px;
    font-family: "poppins";
}

button.primarycolor:focus {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
}
</style>
<style lang="scss">
.vue__time-picker>input {
    border: 1px solid var(--primary_brand) !important;
    border-radius: 5px;
    height: 43px !important;
    padding: 9px 20px !important;
    font-size: 1em;
    margin-top: none !important;
    cursor: default;
}

table.demo-table {
    border-radius: 5px;
    border-spacing: 0;
    border-collapse: separate;
    border: 1px solid #EBEBEB !important;
    overflow: hidden;
    min-width: 900px !important;
    overflow-y: visible !important;

    >thead>tr>th {
        background-color: #e7eeef !important;
        padding: 16px 32px !important;
        font-family: "Poppins", sans-serif !important;
        font-size: 14px !important;
        font-weight: 600;
    }

    >tbody>tr>td {
        font-family: "Poppins", sans-serif !important;
        font-size: 14px !important;
        font-weight: 400 !important;
        color: black !important;
    }

    // >tbody>tr>td:first-child {
    //     text-align: ;
    // }

    /* Apply a border to the right of all but the last column */
    th:not(:last-child),
    td:not(:last-child) {
        border-right: 1px solid #D5D5D5 !important;
    }

    /* Apply a border to the bottom of all but the last row */
    >thead>tr:not(:last-child)>th,
    >thead>tr:not(:last-child)>td,
    >tbody>tr:not(:last-child)>th,
    >tbody>tr:not(:last-child)>td,
    >tfoot>tr:not(:last-child)>th,
    >tfoot>tr:not(:last-child)>td,
    >tr:not(:last-child)>td,
    >tr:not(:last-child)>th,
    >thead:not(:last-child),
    >tbody:not(:last-child),
    >tfoot:not(:last-child) {
        border-bottom: 1px solid #D5D5D5 !important;
    }

    >tbody:last-child>tr>td:first-child>div:last-child {
        border-bottom: none !important;
    }
}
</style>